import { render, staticRenderFns } from "./RolePermissionsModal.vue?vue&type=template&id=c5360338"
import script from "./RolePermissionsModal.vue?vue&type=script&lang=js"
export * from "./RolePermissionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5360338')) {
      api.createRecord('c5360338', component.options)
    } else {
      api.reload('c5360338', component.options)
    }
    module.hot.accept("./RolePermissionsModal.vue?vue&type=template&id=c5360338", function () {
      api.rerender('c5360338', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modules/Settings/RolePermissions/RolePermissionsModal.vue"
export default component.exports